import ResourceCard from "./ResourceCard";
import LearnMore from "./LearnMore";

export default function ResourceSection({ section }) {
  // Non-compact sections go three-up only when the item count divides by three,
  // so 4 items don't sit 3 + 1. `lg` is 1025px in this project's config.
  const gridCols = section.compact
    ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
    : section.items.length % 3 === 0
      ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
      : "grid-cols-1 sm:grid-cols-2";

  return (
    <section className="mt-8">
      <h2 className="m-0 text-base font-semibold text-[#1E2D3D] sm:text-lg">
        {section.title}
      </h2>
      {section.description && (
        <p className="m-0 mt-1 text-sm text-[#555555] sm:text-base">
          {section.description}
        </p>
      )}
      {section.learnMore && (
        <div className="mt-2">
          <LearnMore {...section.learnMore} />
        </div>
      )}

      <div className={`mt-4 grid gap-4 ${gridCols}`}>
        {section.items.map((item) => (
          <ResourceCard key={item.id} item={item} />
        ))}
      </div>
    </section>
  );
}
